// src/services/installPrompt.js
// Установка приложения (Chromium: Android, ПК). beforeinstallprompt приходит один раз и рано —
// перехватываем при старте приложения (index.js), а не в компоненте настроек, иначе событие потеряется.
import { useEffect, useState } from 'react';

let deferredPrompt = null;
let installed = false;
let dismissed = false; // отказались в окне установки — повторно браузер покажет не сразу
const listeners = new Set();

const snapshot = () => ({ canPrompt: Boolean(deferredPrompt), installed, dismissed });

function emit() {
  const state = snapshot();
  listeners.forEach((listener) => listener(state));
}

export function captureInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault(); // своя кнопка в настройках вместо мини-баннера браузера
    deferredPrompt = event;
    emit();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    installed = true;
    emit();
  });
}

export function useInstallState() {
  const [state, setState] = useState(snapshot);
  useEffect(() => {
    listeners.add(setState);
    setState(snapshot());
    return () => listeners.delete(setState);
  }, []);
  return state;
}

// Только по нажатию: prompt() работает лишь из жеста пользователя и лишь один раз на событие
export async function promptInstall() {
  const event = deferredPrompt;
  if (!event) return 'unavailable';
  deferredPrompt = null;
  await event.prompt();
  const { outcome } = await event.userChoice;
  if (outcome === 'accepted') installed = true;
  else dismissed = true;
  emit();
  return outcome;
}
